<div [@toggleExpanded]="isExpanded ? 'expanded' : 'collapsed'">
  <ng-content></ng-content>
</div>
